import React from "react";
import GlfLeaderboard from 'components/sports/glf/views/GlfLeaderboard'

const MyLeaderboard = ({cumulativeData, unitsData, statsData, playerStatsData, favData, setFavData }) => {

  let filteredData = {
    cumulativeResults:{
      progress: cumulativeData?.cumulativeResults?.progress
      ,results: cumulativeData?.cumulativeResults?.results.filter(r => favData.includes(r?.participant?.code) === true)
    }
  } 
  
  return (
    <GlfLeaderboard 
      cumulativeData={filteredData} 
      unitsData={unitsData} 
      statsData={statsData} 
      playerStatsData={playerStatsData} 
      favData={favData} 
      setFavData={setFavData} 
      isMyLeaderboard={true}/>
  )
  
};

export default MyLeaderboard
